'use strict';

var $miniCartQuantity = $('.minicart .minicart-quantity');

module.exports = function () {
    $('.minicart').on('count:update', function (event, count) {
        if (count && $.isNumeric(count.quantityTotal)) {
            var qtyTotal = parseInt(count.quantityTotal, 10);
            if (isNaN(qtyTotal) || qtyTotal <= 0) {
                $miniCartQuantity.addClass('d-none');
            } else {
                $miniCartQuantity.removeClass('d-none');
            }
            $miniCartQuantity.text(count.quantityTotal);
        }
    });
};
